import axios from 'axios';
import {
  FETCH_CHATBOT_CONFIG,
  CREATE_CHATBOT_CONFIG,
  UPDATE_CHATBOT_CONFIG,
  DELETE_CHATBOT_CONFIG,
  SET_CHATBOT_LOADING,
  SET_CHATBOT_ERROR
} from './type';

const BASE_URL = process.env.REACT_APP_PORT;

const head = {
  headers: {
    'x-auth-token': localStorage.getItem('token')
  }
};

// Fetch AI Chatbot Config
export const fetchChatbotConfig = () => async dispatch => {
  dispatch({ type: SET_CHATBOT_LOADING });
  try {
    const res = await axios.get(`${BASE_URL}/api/ai/ai-chatbot-config`, head);
    dispatch({ type: FETCH_CHATBOT_CONFIG, payload: res.data.data });
    return res.data.data;
  } catch (err) {
    dispatch({ type: SET_CHATBOT_ERROR, payload: err.message });
    return null;
  }
};

// Create AI Chatbot Config
export const createChatbotConfig = data => async dispatch => {
  dispatch({ type: SET_CHATBOT_LOADING });
  try {
    const res = await axios.post(`${BASE_URL}/api/ai/ai-chatbot-config`, data, head);
    dispatch({ type: CREATE_CHATBOT_CONFIG, payload: res.data.data });
    return res.data.data;
  } catch (err) {
    dispatch({ type: SET_CHATBOT_ERROR, payload: err.message });
    return null;
  }
};

// Update AI Chatbot Config
export const updateChatbotConfig = data => async dispatch => {
  dispatch({ type: SET_CHATBOT_LOADING });
  try {
    const res = await axios.put(`${BASE_URL}/api/ai/ai-chatbot-config`, data, head);
    dispatch({ type: UPDATE_CHATBOT_CONFIG, payload: res.data.data });
    return res.data.data;
  } catch (err) {
    dispatch({ type: SET_CHATBOT_ERROR, payload: err.message });
    return null;
  }
};

// Delete AI Chatbot Config
export const deleteChatbotConfig = () => async dispatch => {
  dispatch({ type: SET_CHATBOT_LOADING });
  try {
    const res = await axios.delete(`${BASE_URL}/api/ai/ai-chatbot-config`, head);
    dispatch({ type: DELETE_CHATBOT_CONFIG });
    return res.data;
  } catch (err) {
    dispatch({ type: SET_CHATBOT_ERROR, payload: err.message });
    return null;
  }
};
